// components/previews/GraderPreview.jsx
import React, { useState, useEffect } from 'react';
import './GraderPreview.css';

const responses = [
  {
    reasoning: "The student's answer clearly describes the meaning of 'Tawheed', explaining it as the oneness of Allah in His Lordship, Names, and Attributes. It includes an example of how associating partners violates this core belief. The clarity and alignment with rubric expectations justify a full score.",
    score: 10,
    max: 10
  },
  {
    reasoning: "The student defines Tawheed as the oneness of Allah and gives a general example but misses specific mention of categories like Rububiyyah or Asma wa Sifat. This fits rubric level 6 for correct yet incomplete understanding.",
    score: 6,
    max: 10
  },
  {
    reasoning: "The student partially defines Tawheed but lacks clarity and gives no examples. Rubric alignment suggests a score of 4.",
    score: 4,
    max: 10
  },
  {
    reasoning: "No response provided, so no score can be assigned.",
    score: 0,
    max: 10
  }
];

const GraderPreview = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const cycle = setInterval(() => {
      setIndex((prev) => (prev + 1) % responses.length);
    }, 4000);
    return () => clearInterval(cycle);
  }, []);

  const { reasoning, score, max } = responses[index];

  return (
    <div className="grader-preview-container">
      <div className="grader-card">
        <h4 className="response-header">RESPONSE {index + 1}</h4>
        <p><strong>Reasoning:</strong> {reasoning}</p>
        <p className="score-line"><strong>Score:</strong> {score}</p>
        <p className="score-line"><strong>Maximum Score:</strong> {max}</p>
      </div>
    </div>
  );
};

export default GraderPreview;
